// 宿のhttps://github.com/wamazing/onsen-web/blob/develop/src/helpers/wechat/payment_helper.ts から引用

import { KaimonoWebRoutes } from 'src/config/routes';
import { poll, sleep } from 'src/utils/promise';
import { fetchOrderById } from '../api/orderApi';
import { isDevelopment, isStaging } from '../wa/utils/env';

export type WechatpayModalParams = {
  appId: string;
  signType: string;
  timeStamp: string;
  nonceStr: string;
  package: string;
  paySign: string;
};

type WeixinJSBridgeType = {
  invoke(name: string, ...args: any[]): any;
  invoke(api: 'getBrandWCPayRequest', param: WechatpayModalParams, callback: () => void): any;
};

declare const WeixinJSBridge: WeixinJSBridgeType | undefined;
function getWxJsBridge() {
  return new Promise<WeixinJSBridgeType>((resolve, _reject) => {
    if (typeof WeixinJSBridge !== 'undefined') {
      resolve(WeixinJSBridge);
    } else {
      document.addEventListener('WeixinJSBridgeReady', () => getWxJsBridge(), false);
    }
  });
}

function invokeWechatpay(bridge: WeixinJSBridgeType, paymentArgs: WechatpayModalParams): Promise<any> {
  return new Promise((resolve) => {
    bridge.invoke('getBrandWCPayRequest', paymentArgs, resolve);
  });
}

async function requestPayment(paymentArgs: WechatpayModalParams) {
  const wxJsBridge = Promise.race<WeixinJSBridgeType | null>([getWxJsBridge(), sleep(5000).then(() => null)]);

  return wxJsBridge
    .then((bridge) => {
      if (bridge == null) return { err_msg: 'timeout:wechatpay_not_found' };
      return invokeWechatpay(bridge, paymentArgs);
    })
    .then(({ err_msg }) => err_msg);
}

async function checkWechatpayResult(orderId: string, isProxy: boolean) {
  const [dispose, orderResult] = poll(
    () => fetchOrderById(orderId, isProxy),
    (res) => res.isRight() && res.value.status === 'ready' && res.value.paid,
    (res) => res.isLeft(),
    2000
  );
  try {
    const orderRes = await orderResult;
    if (orderRes.isRight()) {
      window.location.href = isProxy
        ? `/kaimono${KaimonoWebRoutes.order.complete(orderRes.value.orderId)}&isProxy=true`
        : `/kaimono${KaimonoWebRoutes.order.complete(orderRes.value.orderId)}`;
    }
  } catch (e) {
    window.alert('微信支付失败。');
  } finally {
    dispose();
  }
}
export async function payWithWechatModal(
  orderId: string,
  wechatpayModalParams: WechatpayModalParams,
  isProxy: boolean
) {
  const result = await requestPayment(wechatpayModalParams);
  switch (result) {
    case 'get_brand_wcpay_request:ok':
      await checkWechatpayResult(orderId, isProxy);
      break;
    case 'get_brand_wcpay_request:cancel':
      // eslint-disable-next-line no-alert
      window.alert('为了完成预约，请在微信上完成支付。');
      // ステージングでwechatpay未開通のアカウントでのテスト用
      if (isStaging()) {
        await checkWechatpayResult(orderId, isProxy);
      }
      break;
    case 'timeout:wechatpay_not_found':
      // ローカル開発用
      if (isDevelopment()) {
        await checkWechatpayResult(orderId, isProxy);
      }
      break;
    case 'get_brand_wcpay_request:fail':
    default:
      // eslint-disable-next-line no-alert
      window.alert('微信支付失败。请再试一次。');
      break;
  }
}
